<div class="search-wrapper">
  <!-- Mobile collapse toggle button (only visible on mobile) -->
  <button class="mobile-collapse-toggle"
          mat-icon-button
          (click)="toggleSearchPanel()"
          [attr.aria-label]="searchPanelCollapsed ? 'Expand search' : 'Collapse search'">
    <mat-icon>{{ searchPanelCollapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
  </button>

  <!-- LEFT column: form + counter -->
  <app-search-form
    class="search-panel"
    [loading]="loading"
    [error]="error"
    [annaDomains]="annaDomains"
    [downloadsLeft]="downloadsLeft"
    [downloadsPerDay]="downloadsPerDay"
    [relatedBooksModalOpen]="relatedBooksModalOpen"
    [collapsed]="searchPanelCollapsed"
    (search)="onSearchFormSubmit($event)"
    (openRelatedBooks)="onOpenRelatedBooks($event)"
    (toggleCollapsed)="toggleSearchPanel()"
    (formatChange)="onFormatChange($event)"
  ></app-search-form>

  <!-- RIGHT column: results -->
  <app-search-results
    class="results-panel"
    [books]="filteredBooks"
    [loading]="loading"
    [searchPerformed]="searchPerformed"
    [placeholderUrl]="placeholderUrl"
    (sendToLibrary)="onResultSendToLibrary($event)"
    (sendToDropbox)="onResultSendToDropbox($event)"
    (sendToKindle)="onResultSendToKindle($event)"
    (fetchDescription)="onResultFetchDescription($event)"
    (coverError)="onResultCoverError($event)"
  ></app-search-results>
</div>
